module.exports = __webpack_public_path__ + "static/media/wolin.832eaebd.jpg";